import tldsInCart from "lib/tldsInCart";
import getSkipPackageSelectPageSettings from "../../settings/getSkipPackageSelectPageSettings";

const debug = false;

function log(message) {
  if (debug && process.env.NODE_ENV === "development" && message) {
    console.log(message);
  }
}

export default function shouldSkipPackageSelectPage(state) {
  const { onecomConfig, cart } = state;
  const { countryCode, testVersion } = onecomConfig;
  const { cartItems, hostingAutoAddedToCart, chosenPackage } = cart;
  const upsellSettings = getSkipPackageSelectPageSettings();

  // TODO: Optimize this! This is just a hurry fix introduced after deadline:
  if (testVersion === "B-0027") {
    if (["ES", "DK"].includes(countryCode)) {
      const isDomainEmailBundle = !!cartItems.find((cartItem) => {
        return (
          cartItem.fullDomain &&
          cartItem.webSpaceSize === "PPS_EMAIL" &&
          cartItem.lines.length <= 2
        );
      });

      if (isDomainEmailBundle) {
        return true;
      }
    }
  }

  if (!upsellSettings) {
    return false;
  }

  const applicableSettings = upsellSettings.filter(({ appliesToCountries }) => {
    return (
      appliesToCountries === "all" || appliesToCountries.includes(countryCode)
    );
  });

  if (!applicableSettings || !applicableSettings.length) {
    return false;
  }

  log(applicableSettings);

  const shouldSkipPackageSelectPage = applicableSettings.every((settings) => {
    if (settings.itemsInCart) {
      const { itemsInCart } = settings;

      if (typeof itemsInCart === "number") {
        if (cartItems.length !== itemsInCart) {
          log("Failed on itemsInCart");
          return false;
        }
      }

      if (typeof itemsInCart === "string") {
        const match = itemsInCart.match(/(less than|greater than|equals) (\d)/);

        const identifier = match[1];
        const value = parseInt(match[2]);

        log("cartItems:", cartItems.length, "identifier:", itemsInCart);

        if (cartItems.length === 0) {
          log("Failed on itemsInCart (cart empty)");
          return false;
        }

        if (identifier === "less than") {
          if (cartItems.length >= value) {
            log("Failed on itemsInCart (less than)");
            return false;
          }
        }

        if (identifier === "equals") {
          if (cartItems.length !== value) {
            log("Failed on itemsInCart (equals)");
            return false;
          }
        }

        if (identifier === "greater than") {
          log("Failed on itemsInCart (greater than)");
          if (cartItems.length <= value) {
            return false;
          }
        }
      }
    }

    if (settings.chosenPackage && chosenPackage !== settings.chosenPackage) {
      log("Failed on chosenPackage");
      return false;
    }

    if (settings.tlds) {
      const getTldsInCart = tldsInCart(cartItems);
      let requirementPassed = false;

      for (const tld of settings.tlds) {
        const isRequiredTldInCart = getTldsInCart.some(
          (tldInCart) => tldInCart === tld,
        );
        if (isRequiredTldInCart) {
          requirementPassed = true;
          break;
        }
      }

      if (!requirementPassed) {
        log("Failed on tlds");
        return false;
      }
    }

    if (settings.hasAnyAddonsInCart !== null) {
      if (cartItems.length < 1) {
        log("Failed on hasAnyAddonsInCart (no items in cart)");
        return false;
      }

      const hasAnyCartItemAnyAddon = cartItems.some((item) => {
        return (
          Array.isArray(item.addonProducts) && item.addonProducts.length > 0
        );
      });

      if (settings.hasAnyAddonsInCart && !hasAnyCartItemAnyAddon) {
        log("Failed on hasAnyAddonsInCart (no addons in cart)");
        return false;
      }

      if (!settings.hasAnyAddonsInCart && hasAnyCartItemAnyAddon) {
        log("Failed on hasAnyAddonsInCart (has addons in cart)");
        return false;
      }
    }

    if (settings.testVersion && testVersion !== settings.testVersion) {
      log("Failed on testVersion");
      return false;
    }

    if (settings.planChosenByCustomer) {
      if (
        hostingAutoAddedToCart ||
        ["PPS_EMAIL", "DOMAIN_ONLY"].includes(chosenPackage)
      ) {
        log("Failed on planChosenByCustomer");
        return false;
      }
    }

    return true;
  });

  return shouldSkipPackageSelectPage;
}
